// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2BNpr","label":"styles_label__HI8wq"};